module.exports = __webpack_public_path__ + "img/21_windAndRain_zxj.6f6b4007.png";